import React from 'react'
import { useDispatch } from 'react-redux'
import Title from './components/Title'
import ObjectHome from './components/ObjectHome'
import ButtonStart from '../ButtonStart'
import { setHomeScreen } from '../../redux/reducers/screens'
import '../../styles/components/Homescreen.scss'

const HomeScreen = () => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(setHomeScreen())
  }

  return (
    <div className="HomeScreen" data-testid="home-screen">
      <Title />
      <ObjectHome />
      <ButtonStart onClick={handleClick}>ENTER</ButtonStart>
    </div>
  )
}

export default HomeScreen
